import { computed } from 'vue'
import { createItemStore } from '~/utils/pinia/light-item-store'
import { usePickemApi } from '~/services/api'
import type { Stage } from '../types'

// Хранит активный (выбранный на UI) Stage целиком.
// Mutations пиков апплаят локально через updateData() для оптимистичных
// апдейтов, см. stores/predictions.ts.
export const useStageStore = createItemStore(
  'pickem-stage',
  {
    getItemRequest: async () => {
      const pickemApi = usePickemApi()
      return (id: Stage['id']) => pickemApi.getStageById(id)
    }
  },
  context => {
    const stage = computed(() => context.data.value)
    const isSwiss = computed(() => stage.value?.type === 'swiss')
    const isBracket = computed(() => stage.value?.type === 'bracket')

    // Команды, которые ещё НЕ разложены по категориям. Палитра берёт это.
    const unassignedSwissTeams = computed(() => {
      const value = stage.value
      if (!value || !value.swiss) return []
      const placed = new Set(value.swiss.predictions.map(p => p.team_id))
      return value.teams.filter(team => !placed.has(team.id))
    })

    return { stage, isSwiss, isBracket, unassignedSwissTeams }
  }
)
